// Mock data for KTSauto clone (frontend-only phase)

export const categories = [
  { slug: "freinage", name: "Freinage", image: "https://images.unsplash.com/photo-1613214150384-14921ff659b2?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { slug: "filtration", name: "Filtration", image: "https://images.unsplash.com/photo-1777118947168-b6e806cb80cf?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { slug: "embrayage", name: "Embrayage", image: "https://images.unsplash.com/photo-1603925246538-193f96ec9acd?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { slug: "suspension", name: "Suspension", image: "https://images.unsplash.com/photo-1770400770299-4940896a198b?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { slug: "batteries", name: "Batteries", image: "https://images.pexels.com/photos/32282232/pexels-photo-32282232.jpeg?auto=compress&cs=tinysrgb&w=940" },
];

// Full navigation categories (nav bar)
export const navCategories = [
  { slug: "freinage", name: "Freinage" },
  { slug: "filtration", name: "Filtration" },
  { slug: "embrayage", name: "Embrayage" },
  { slug: "suspension", name: "Suspension" },
  { slug: "electricite", name: "Électricité" },
  { slug: "moteur", name: "Moteur" },
  { slug: "carrosserie", name: "Carrosserie" },
  { slug: "echappement", name: "Échappement" },
  { slug: "accessoires", name: "Accessoires" }
];

export const brands = ["Bosch", "Valeo", "Brembo", "NGK", "Mann-Filter", "Sachs", "Febi Bilstein", "Varta", "Monroe", "TRW"];

export const products = [
  {
    id: "p1", name: "Kit de disques de frein avant ventilés", ref: "BR-2451-AV", brand: "Brembo",
    category: "freinage", price: 89.90, oldPrice: 119.90, rating: 4.7, reviews: 214, stock: 24,
    image: "https://images.unsplash.com/photo-1613214150384-14921ff659b2?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Jeu de 2 disques de frein avant ventilés haute performance. Compatible de nombreux modèles. Traitement anticorrosion."
  },
  {
    id: "p2", name: "Plaquettes de frein avant (jeu de 4)", ref: "PL-8890-AV", brand: "TRW",
    category: "freinage", price: 34.50, oldPrice: 44.90, rating: 4.6, reviews: 187, stock: 40,
    image: "https://images.pexels.com/photos/34277923/pexels-photo-34277923.jpeg?auto=compress&cs=tinysrgb&w=940",
    desc: "Plaquettes de frein avant faible émission de poussière. Freinage silencieux et endurant."
  },
  {
    id: "p3", name: "Filtre à huile moteur premium", ref: "FH-1120", brand: "Mann-Filter",
    category: "filtration", price: 9.90, oldPrice: 13.50, rating: 4.8, reviews: 356, stock: 120,
    image: "https://images.unsplash.com/photo-1777118947168-b6e806cb80cf?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Filtre à huile haute filtration pour une protection optimale du moteur. Montage rapide."
  },
  {
    id: "p4", name: "Filtre à air moteur", ref: "FA-3345", brand: "Bosch",
    category: "filtration", price: 14.20, oldPrice: null, rating: 4.5, reviews: 98, stock: 75,
    image: "https://images.unsplash.com/photo-1522598140461-ec9911e01c53?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Filtre à air papier plicel pour une admission d'air propre et un rendement moteur optimal."
  },
  {
    id: "p5", name: "Kit d'embrayage complet 3 pièces", ref: "EM-7781", brand: "Sachs",
    category: "embrayage", price: 189.00, oldPrice: 239.00, rating: 4.7, reviews: 142, stock: 12,
    image: "https://images.unsplash.com/photo-1603925246538-193f96ec9acd?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Kit d'embrayage complet: mécanisme, disque et butée. Durabilité renforcée."
  },
  {
    id: "p6", name: "Disque d'embrayage renforcé", ref: "EM-4432", brand: "Valeo",
    category: "embrayage", price: 74.90, oldPrice: null, rating: 4.4, reviews: 63, stock: 30,
    image: "https://images.unsplash.com/photo-1610847575605-989e71100be5?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Disque d'embrayage à garnitures organiques pour un passage de vitesses en douceur."
  },
  {
    id: "p7", name: "Amortisseur arrière à gaz", ref: "SU-9902-AR", brand: "Monroe",
    category: "suspension", price: 59.90, oldPrice: 79.90, rating: 4.6, reviews: 121, stock: 18,
    image: "https://images.unsplash.com/photo-1770400770299-4940896a198b?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Amortisseur à gaz pour un confort de conduite et une tenue de route améliorée."
  },
  {
    id: "p8", name: "Batterie 12V 74Ah 680A", ref: "BAT-7468", brand: "Varta",
    category: "batteries", price: 109.90, oldPrice: 134.90, rating: 4.8, reviews: 289, stock: 22,
    image: "https://images.pexels.com/photos/32282232/pexels-photo-32282232.jpeg?auto=compress&cs=tinysrgb&w=940",
    desc: "Batterie de démarrage sans entretien, forte capacité. Garantie 2 ans."
  },
  {
    id: "p9", name: "Batterie 12V 60Ah 540A", ref: "BAT-6054", brand: "Bosch",
    category: "batteries", price: 89.90, oldPrice: null, rating: 4.7, reviews: 156, stock: 34,
    image: "https://images.pexels.com/photos/37177070/pexels-photo-37177070.jpeg?auto=compress&cs=tinysrgb&w=940",
    desc: "Batterie fiable pour citadines et compactes. Technologie calcium/calcium."
  },
  {
    id: "p10", name: "Bougies d'allumage iridium (jeu de 4)", ref: "EL-1140", brand: "NGK",
    category: "electricite", price: 39.90, oldPrice: 49.90, rating: 4.9, reviews: 402, stock: 88,
    image: "https://images.unsplash.com/photo-1670764169470-bd2f737f9248?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Bougies iridium longue durée pour un allumage optimal et une consommation maîtrisée."
  },
  {
    id: "p11", name: "Alternateur 140A reconditionné", ref: "EL-9987", brand: "Valeo",
    category: "electricite", price: 219.00, oldPrice: 289.00, rating: 4.5, reviews: 74, stock: 8,
    image: "https://images.unsplash.com/photo-1654166827605-974dd2e9bb1e?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Alternateur reconditionné testé en usine. Performances équivalentes au neuf."
  },
  {
    id: "p12", name: "Bougies d'allumage standard (jeu de 4)", ref: "EL-2231", brand: "NGK",
    category: "electricite", price: 19.90, oldPrice: null, rating: 4.6, reviews: 133, stock: 95,
    image: "https://images.pexels.com/photos/36086528/pexels-photo-36086528.jpeg?auto=compress&cs=tinysrgb&w=940",
    desc: "Bougies d'allumage nickel pour un fonctionnement moteur régulier."
  },
  {
    id: "p13", name: "Kit de distribution complet", ref: "MO-5567", brand: "Febi Bilstein",
    category: "moteur", price: 129.00, oldPrice: 169.00, rating: 4.7, reviews: 91, stock: 15,
    image: "https://images.unsplash.com/photo-1588294020274-1e23a4815b72?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Kit de distribution: courroie, galets et tendeur. Remplacement conseillé selon préconisations."
  },
  {
    id: "p14", name: "Disque de frein moto avant", ref: "MOTO-3321", brand: "Brembo",
    category: "pieces-moto", price: 129.90, oldPrice: 159.90, rating: 4.8, reviews: 67, stock: 11,
    image: "https://images.unsplash.com/photo-1588017530244-c57df911f73b?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Disque de frein flottant moto, acier inoxydable. Dissipation thermique optimale."
  },
  {
    id: "p15", name: "Kit chaîne moto + pignons", ref: "MOTO-8890", brand: "NGK",
    category: "pieces-moto", price: 74.90, oldPrice: null, rating: 4.6, reviews: 52, stock: 20,
    image: "https://images.unsplash.com/photo-1613214150384-14921ff659b2?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Kit chaîne renforcée avec pignons et couronne. Longue durée de vie."
  },
  {
    id: "p16", name: "Pare-chocs avant apprêté", ref: "CA-1102", brand: "Valeo",
    category: "carrosserie", price: 149.00, oldPrice: 199.00, rating: 4.3, reviews: 38, stock: 6,
    image: "https://images.unsplash.com/photo-1603925246538-193f96ec9acd?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Pare-chocs avant apprêté prêt à peindre. Fixations d'origine."
  },
  {
    id: "p17", name: "Silencieux d'échappement arrière", ref: "EC-4451", brand: "Bosch",
    category: "echappement", price: 84.90, oldPrice: 109.90, rating: 4.5, reviews: 44, stock: 14,
    image: "https://images.unsplash.com/photo-1770400770299-4940896a198b?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Silencieux arrière en acier aluminisé. Réduction sonore optimale."
  },
  {
    id: "p18", name: "Balais d'essuie-glace avant (paire)", ref: "AC-2290", brand: "Bosch",
    category: "accessoires", price: 22.90, oldPrice: 29.90, rating: 4.7, reviews: 210, stock: 60,
    image: "https://images.unsplash.com/photo-1522598140461-ec9911e01c53?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Balais d'essuie-glace plats aerodynamiques. Essuyage silencieux et efficace."
  }
];

export const getProductsByCategory = (slug) => products.filter((p) => p.category === slug);
export const getProductById = (id) => products.find((p) => p.id === id);
export const getCategoryName = (slug) => {
  const all = [...navCategories, ...categories];
  const found = all.find((c) => c.slug === slug);
  return found ? found.name : slug;
};
